import React, { useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    Grid,
    Typography,
    Box,
    Divider,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import TextInput from "qubCommon/Inputs/TextInput";

const ApplicationTypeDialog = ({
    open,
    onClose,
    onSubmit,
    defaultValues = {},
}) => {
    const methods = useForm({
        defaultValues,
    });

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const isEdit = !!defaultValues?.id;

    // Reset form when editing a different row
    useEffect(() => {
        methods.reset(defaultValues);
    }, [defaultValues, methods]);

    const handleSubmit = (data) => {
        onSubmit({
            id: defaultValues?.id || null,
            description: data.description,
            abbr: data.abbr,
            position: Number(data.position),
            isActive: !!data.isActive,
        });
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            fullScreen={isMobile}
            PaperProps={{
                sx: {
                    borderRadius: isMobile ? 0 : 3,
                    p: 0,
                    overflow: "hidden",
                },
            }}
        >
            {/* Header */}
            <Box sx={{ backgroundColor: "#f5f8fa", px: 3, py: 2 }}>
                <Typography variant="h4" fontWeight={700} color="primary">
                    {isEdit
                        ? "Επεξεργασία Είδους Αίτησης"
                        : "Νέο Είδος Αίτησης"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Συμπληρώστε τα στοιχεία του είδους αίτησης.
                </Typography>
            </Box>

            <Divider />

            {/* Form */}
            <FormProvider {...methods}>
                <DialogContent sx={{ px: 3, py: 3, backgroundColor: "#fff" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextInput
                                name="description"
                                label="Περιγραφή"
                                isFullWidth
                                rules={{ required: "Απαιτείται περιγραφή" }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextInput
                                name="abbr"
                                label="Σύντμηση"
                                isFullWidth
                                rules={{ required: "Απαιτείται σύντμηση" }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextInput
                                name="position"
                                label="Σειρά"
                                isFullWidth
                                rules={{ required: "Απαιτείται σειρά" }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        {...methods.register("isActive")}
                                        color="primary"
                                        defaultChecked={!!defaultValues?.isActive}
                                    />
                                }
                                label="Ενεργός"
                                sx={{ mt: 1 }}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>

                <Divider />

                {/* Actions */}
                <DialogActions
                    sx={{
                        backgroundColor: "#f9f9f9",
                        py: 2,
                        px: 3,
                        justifyContent: "space-between",
                        flexWrap: "wrap",
                    }}
                >
                    <Button onClick={onClose} variant="contained" color="error">
                        Ακύρωση
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        onClick={methods.handleSubmit(handleSubmit)}
                        sx={{ px: 3 }}
                    >
                        {isEdit ? "Αποθήκευση Αλλαγών" : "Αποθήκευση"}
                    </Button>
                </DialogActions>
            </FormProvider>
        </Dialog>
    );
};

export default ApplicationTypeDialog;
